import React from 'react';
import { PAGE_SIZE_OPTIONS } from '../lib/pagination';

/**
 * Liste ekranlarının "sayfa başına kaç satır" seçicisi.
 *
 * Seçenek kümesi `lib/pagination` içindedir ve backend'deki `limit` tavanıyla
 * aynı kalmalıdır; ekran başına yazılsaydı biri listede olmayan bir değeri
 * sunar ve istek 422 alırdı.
 */
const PageSizeSelect = ({ value, onChange, disabled = false, id }) => (
  <label className="flex items-center gap-2 text-xs text-slate-500">
    <span className="hidden sm:inline">Sayfa başına</span>
    <select
      id={id}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(Number(event.target.value))}
      className="admin-input admin-input-w-sm disabled:opacity-40"
      aria-label="Sayfa başına satır sayısı"
    >
      {PAGE_SIZE_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </label>
);

export default PageSizeSelect;
